import { Injectable } from '@angular/core';
import { UIRouter }   from '@uirouter/core';

import { TranslateService } from '@ngx-translate/core';

import { BranchesLiteApiService } from '../branches/branches-lite.service';
import { CarfaxService }          from '../carfax/carfax.service';
import { MessagesService }        from '../messages/messages.service';
import { UKPostcodeService }      from '../uk-postcode/uk-postcode.service';
import { VVGarageFactory }        from '../../app/vv-garage/vv-garage.service';

import { CustomerModel } from './models/customer';
import { InvoiceModel }  from '../invoices/models/invoice';

@Injectable()
export class CustomerIntegrationsService {
  branchInvoices       : InvoiceModel[] = [];
  branchPaymentsHO     : Record<string, unknown>[] = [];
  branchPaymentsStores : Record<string, unknown>[] = [];

  private customer : CustomerModel;
  private VVGarage : any;

  constructor (
    private branchesApi      : BranchesLiteApiService,
    public  carfaxApi        : CarfaxService,
    private messagesService  : MessagesService,
    private router           : UIRouter,
    private translateService : TranslateService,
    private ukPostcodeApi    : UKPostcodeService,
    private vvGarageFactory  : VVGarageFactory
  ) {}

  init (opts: { customer: CustomerModel; isBranchCustomer: boolean }) : void {
    this.customer = opts.customer;
    this.VVGarage = this.vvGarageFactory.create(opts.customer);

    if (opts.isBranchCustomer) {
      this.branchesApi.getCustomerPayments(this.customer.id)
        .then(payments => {
          this.branchPaymentsHO = payments.branch;
          this.branchPaymentsStores = payments.stores;
        }).catch(err => this.messagesService.error(err));

      this.branchesApi.getCustomerInvoices(this.customer.id)
        .then(invoices => this.branchInvoices = invoices)
        .catch(err => this.messagesService.error(err));
    }
  }

  // --- VV Garage ---

  addCustomerToVVGarage () : void {
    this.VVGarage?.add_customer()
    .then(() => {
      this.messagesService.show(this.translateService.instant('VV_GARAGE_SPACE.CUSTOMER_ADDED_TO_VV_GARAGE'), 'success');
      this.router.stateService.reload();
    }).catch(err => this.messagesService.error(err));
  }

  removeCustomerFromVVGarage () : void {
    this.VVGarage?.delete_customer()
    .then(() => {
      this.messagesService.show(this.translateService.instant('VV_GARAGE_SPACE.CUSTOMER_REMOVED_FROM_VV_GARAGE'), 'success');
      this.router.stateService.reload();
    }).catch(err => this.messagesService.error(err));
  }

  // --- UK Postcode ---

  searchUKPostcode (type = 'customer') : void {
    const postcode = type === 'customer' ? this.customer.postcode : this.customer.postal_postcode;
    this.ukPostcodeApi.search(postcode).then(data => {
      if (type === 'postal') {
        this.customer.postal_address1 = data.Premises;
        this.customer.postal_address2 = data.Street;
        this.customer.postal_suburb = data.PostTown;
        this.customer.postal_postcode = data.Postcode;
      } else {
        this.customer.address1 = data.Premises;
        this.customer.address2 = data.Street;
        this.customer.suburb = data.PostTown;
        this.customer.postcode = data.Postcode;
      }
      this.messagesService.show(this.translateService.instant('CUSTOMER_SPACE.CUSTOMER_ADDRESS_UPDATED'), 'success');
    }).catch(err => this.messagesService.error(err));
  }
}
